import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import BarArrowButton from './BarArrowButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'LinkAccountsShoutPanel',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(BarArrowButton, {
                flex: true,
                large: true,
                class: "linkAccounts",
                title: "Spending Analysis",
                href: "/#/money?add=true",
                bgImage: require('@/assets/bg/marbles.png')
            }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                    _createElementVNode("div", { class: "barArrowButtonSlotContent" }, [
                        _createElementVNode("a", { href: '/#/money?add=true' }, [
                            _createElementVNode("p", { class: "small" }, "Link your bank account to get started.")
                        ])
                    ], -1)
                ])),
                _: 1
            }, 8, ["bgImage"]));
        };
    }
});
